import "./CompLoader.scss";

const CompLoader = () => {
  return (
    <div className="loader_cont">
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default CompLoader;
